var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.3 12.7L7.6 7v-.2-.2L1.3.6","stroke":"currentColor","strokeWidth":"1.1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 9 14"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
